import { useLocation } from "wouter";

import { useAskAboutTask } from "./api.ts";

/**
 * The ask, which opens the conversation it starts. The row holds it, so its
 * other actions wait while an ask runs: an ask and a hand-off at once would
 * each start the task's conversation.
 */
export const useAskAbout = () => {
  const [, navigate] = useLocation();
  // From the mutation, not `mutate`: a list refetch can remount the row first.
  return useAskAboutTask(({ threadId }) => navigate(`/threads/${threadId}`));
};
